import { render, staticRenderFns } from "./storePerformance.vue?vue&type=template&id=6ec1f750&scoped=true"
import script from "./storePerformance.vue?vue&type=script&lang=js"
export * from "./storePerformance.vue?vue&type=script&lang=js"
import style0 from "./storePerformance.vue?vue&type=style&index=0&id=6ec1f750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec1f750",
  null
  
)

export default component.exports